<div class="content">
  <div class="title-card">
    <h1 class="page-title">
      Audit Logs
    </h1>
  </div>
  <mat-card class="pt-3 results">
    <div class="actions content">
      <app-search
        class="d-flex"
        [dateOptions]="dateOptions"
        [filterFactories]="filterFactories"
        (queryBuilt)="queryBuilt($event)"
      ></app-search>
      <div class="text-center mt-2" *ngIf="showEmptyResultMessage">No results found.<br><br></div>
      <ng-container *ngIf="!showEmptyResultMessage">
        <table
          mat-table [dataSource]="dataSource" class="log-table" aria-describedby="title"
          matSort matSortActive="createdDate" matSortDirection="desc"
        >
          <ng-container matColumnDef="userName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="">User Name</th>
            <td mat-cell *matCellDef="let record">
              <span>{{record.userName}}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="">Action</th>
            <td mat-cell *matCellDef="let record">
              <span (click)="openDetail(record)">{{record.action}}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="createdDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="">Date</th>
            <td mat-cell *matCellDef="let record">
              <span>{{record.createdDate | localDate}}</span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row class="app-row" *matRowDef="let record; columns: displayedColumns;"></tr>
        </table>
        <mat-paginator #paginator [pageSize]="50"
                       [length]="totalElements"
                       showFirstLastButtons [pageSizeOptions]="[10, 25, 50]"
                       aria-label="Select page of periodic elements">
        </mat-paginator>
      </ng-container>
    </div>
  </mat-card>
</div>

